import toArray from 'lodash/toArray';
import React from 'react';
import { META_EVENTS } from '../../../constants/CONTROLLERS_EVENT_TYPES';
import useTableSelector from '../../../hooks/useTableSelector';
import { ICategory } from '../../../types/category';
import SeatSelector from './SeatsSelector';
import SectorsTable from './SectorsTable';
import Styled from './styles';

interface TableSelectorProps {
  isFullscreen?: boolean;
}

const TableSelector = ({ isFullscreen }: TableSelectorProps) => {
  const { Widget } = window;
  const { selectedSector, sectors, categories, dates, selectSector } = useTableSelector();

  return (
    <Styled.Wrapper isFullscreen={isFullscreen} withDates={dates && dates.length > 0}>
      {!selectedSector ? (
        <SectorsTable
          onSelect={(sector) => {
            selectSector(sector);
            Widget.metaController.emit(META_EVENTS.CHANGE_SECTOR, sector);
          }}
          sectors={sectors.filter((sector) => sector.ticketsCount)}
          categories={toArray<any>(categories).filter((category: ICategory) => category.count)}
        />
      ) : (
        <SeatSelector sector={selectedSector} isFullscreen={isFullscreen} />
      )}
    </Styled.Wrapper>
  );
};

export default TableSelector;
